import * as React from "react";
import {Box} from "@mui/material";
import {useDraggable} from "@dnd-kit/core";
import {styles} from "./LeadPipelineStyles";
import LeadPipelineCardDetails from "./LeadPipelineCardDetails";

export default function LeadPipelineCard({lead, stage, isDraggable, showsCommercialChannel}) {
    const style = styles();
    const {attributes, listeners, setNodeRef, isDragging} = useDraggable({
        id: lead.id,
        data: {stage, lead},
        disabled: !isDraggable,
    });
    const cardStyle = [
        style.card,
        style.cardToneOfStage(stage),
        isDraggable && style.draggableCard,
        isDragging && style.cardLeftBehindWhileDragging,
    ];

    return (
        <Box ref={setNodeRef} sx={cardStyle} {...listeners} {...attributes}>
            <LeadPipelineCardDetails lead={lead} stage={stage} showsCommercialChannel={showsCommercialChannel}/>
        </Box>
    );
}
